import { validateForms } from '../functions/validate-forms';
// import JustValidate from 'just-validate';
// import Inputmask from "inputmask";

const rules1 = [
  {
    ruleSelector: '.form [type="email"]',
    rules: [
      {
        rule: 'required',
        errorMessage: 'Обязательное поле',
      },
      {
        rule: 'email',
        errorMessage: 'Некорректный ввод email',
      }
    ],
  },
  {
    ruleSelector: '.name',
    rules: [
      {
        rule: 'required',
        errorMessage: 'Обязательное поле',
      },
      {
        rule: 'minLength',
        value: 3,
        errorMessage: 'Не меньше 3 символов',
      },
      {
        rule: 'maxLength',
        value: 15,
        errorMessage: 'Не более 15 символов',
      },
    ],
  },
  {
    ruleSelector: '.form [type="tel"]',
    tel: true,
    telError: 'Введите корректный телефон',
    rules: [
      {
        rule: 'required',
        value: true,
        errorMessage: 'Заполните телефон!'
      }
    ]
  },
];


const deep = structuredClone(rules1)
// console.log(deep)
// console.log(deep[1] === rules1[1])

const afterForm = () => {
  console.log('Произошла отправка, тут можно писать любые действия');
};

let forms = document.querySelectorAll('.form')
forms.forEach((el) => {
  validateForms(el, rules1, afterForm);
})



// validateForms('.certification .form', rules1, afterForm);

// validateForms('.employment .form', rules1, afterForm);

// validateForms('.call .form', rules1, afterForm);
